




































import { Component, Vue } from 'vue-property-decorator';
import * as dd from 'dingtalk-jsapi';
import { qrcodeApis } from '../api';
import { DingtalkCorpId, isInDingtalk } from '@/common/dingtalk';

@Component
export default class QrcodeConfirmedIndex extends Vue {
  errorMessage = '';
  confirmLoading = false;
  step: 'confirmed' | 'scan' | 'stop' | 'error' = 'scan';
  userDisplayName = '';

  countdownContent = '';
  countdown = 5;

  mounted() {
    if (!isInDingtalk()) {
      this.errorMessage = '请使用钉钉进行扫码登录';
      this.step = 'error';
      return;
    }

    this.step = 'scan';
    setTimeout(() => {
      // 不可以去掉延时，会有拿不到路由的bug
      dd.ready(() => {
        dd.runtime.permission
          .requestAuthCode({
            corpId: DingtalkCorpId
          })
          .then(async (info: any) => {
            const code = info.code;
            this.verifyScan(code);
          });
      });
    }, 500);
  }

  get qrcodeId() {
    return this.$route.query.qrcode_id as string;
  }

  async verifyScan(dingtalkCode: string) {
    try {
      console.log('verifyScan', this.qrcodeId, this.$route);
      const data = await qrcodeApis.scanLogin(this.qrcodeId, dingtalkCode);
      this.userDisplayName = data.display_name;
      this.step = 'confirmed';
    } catch (e) {
      console.error(e);
      this.errorMessage = e.message || '验证扫码信息失败，请重试';
      this.step = 'error';
    }
  }

  async confirmLogin() {
    this.confirmLoading = true;
    try {
      await qrcodeApis.scanLoginConfirm(this.qrcodeId);
      this.readyToClose();
    } catch (e) {
      console.error(e);
      this.errorMessage = e.message || '确认登录失败，请重试';
      this.step = 'error';
    } finally {
      this.confirmLoading = false;
    }
  }

  readyToClose() {
    this.step = 'stop';
    const interval = setInterval(() => {
      this.countdown -= 1;
      this.countdownContent = `页面将在 ${this.countdown} 秒后自动关闭`;
      if (this.countdown <= 0) {
        clearInterval(interval);
        window.close();
        setTimeout(() => {
          this.countdownContent = '请手动关闭此页面';
        }, 100);
      }
    }, 1000);
  }
}
